import {initParam} from "../setting/initParam";
import {
    CalcPlaceFromDiagonalY, centeredLine, createDefaultMaterial,
    getMetaNumber,
    getOffsetsAfterRotation, InitialStruct,
    JoinPlane,
    JoinType,
    JoinVariant,
    Line2,
    matBeam, ParamsGetSimpleBoard, RenderElement,
    RenderStruct, simpleSize, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";
import {locale} from "../setting/locale";


export async function getF3(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {
    const lang = new URLSearchParams(window.location.search).get('lang') as 'en'|'de'|'ru' || 'en';

    const H = initParam.elementData.f2.sizeBoard.l - initParam.gash.simple - initParam.gash.simple

    const placeInfo = CalcPlaceFromDiagonalY(s.a, H)

    initParam.elementData.f3.sizeBoard.l = placeInfo.l

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: placeInfo.l},
        cuts: [],
        joinEnd: {
            joinType: JoinType.End,
            joinPlane: JoinPlane.Top,
            indent: 0,
            angle:  90-s.a,
            variant: JoinVariant.Angle
        },
        joinStart: {
            joinType: JoinType.Start,
            joinPlane: JoinPlane.Top,
            indent: 0,
            angle:  s.a,
            variant: JoinVariant.Angle,
        },
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = 'F3'
    rs.group = nameGroup
    const numGroups = rs.group.length
    const meta = resultGetSimpleBoard.meta
    // initParam.maps.f3.meta = meta

    const realSeg = centeredLine(initParam.maps.f1.lineCut, s.l)

    const metaJEOffsetEnd = getMetaNumber(meta.modify, "joinEnd", "offset")
    const metaJEOffsetStart = getMetaNumber(meta.modify, "joinStart", "offset")

    const metaF3WidthEnd = getMetaNumber(meta.modify, "joinEnd", "width")
    const metaF3WidthStart = getMetaNumber(meta.modify, "joinStart", "width")

    initParam.maps.f3.diagonal = [[0, placeInfo.h - metaF3WidthEnd], [placeInfo.w - metaF3WidthStart, 0]]

    const line1:Line2 = [[meta.h / 2, 0],[meta.h / 2, meta.l]]
    const line2:Line2 = [[-meta.h / 2, 0 + metaJEOffsetStart], [-meta.h / 2, meta.l - metaJEOffsetEnd]]

    const p:Line2[] = [line1, line2]

    const testOfset = getOffsetsAfterRotation(p, Math.PI / 2 - s.r)

    for (let i = 0; i < realSeg.length; i++) {
        const x = realSeg[i][0]


        const z = s.h
            - initParam.gash.simple
            + initParam.elementData.f1.sizeBoard.h
            + placeInfo.l / 2
            - testOfset.deltaBottom

        const yR = 0
            - initParam.elementData.f2.sizeBoard.w
            - testOfset.deltaLeft

        const yL = 0
            + initParam.elementData.f2.sizeBoard.w
            + testOfset.deltaLeft

        const posR:Vec3 = [x, z, yR]
        const posL:Vec3 = [x, z, yL]

        const boardR: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posR,
            // rotation: [Math.PI / 2, 0, 0],
            rotation: [Math.PI / 2 - s.r, 0, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
        }
        rs.elements.push(boardR)

        const boardL: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posL,
            rotation: [-Math.PI / 2 + s.r, Math.PI, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
        }
        rs.elements.push(boardL)
    }

    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: "F3",
        group: locale['truss'][lang],
        count: (realSeg.length - 1) * 2,
    })

    return {rs: rs, spec: spec}
}
